import React from "react";
import DataTableComponent from "../../../Shared/Table";
import { useSelector } from "react-redux";
import EditTableIcon from "../../../.../../../assets/images/edit-table-icon.svg";
import deleteIcon from "../../../.../../../assets/images/delete.png";

const Table = ({
  rewards,
  setIsAddRewardModalOpen,
  setIsDeleteRewardModalOpen,
  setDeleteRewardId,
  setEditRewardId,
}) => {
  const { sellers } = useSelector((state) => state.appReducer);
  const { role, name } = useSelector((state) => state.authReducer);

  const tableData = (rewards || []).map((reward) => ({
    ...reward,
    expiryDate:
      reward?.endDate === "unlimited"
        ? "Unlimited"
        : reward?.endDate?.split("T")[0]
        ? reward?.endDate?.split("T")[0]
        : "Invalid Date",
    rewardName: reward?.rewardName || "-",
    rewardType: reward?.rewardType || "-",

    setBy:
      role === "seller"
        ? name
        : sellers?.find((seller) => seller.id === reward?.sellerId)?.name,
  }));

  const productsColumns = [
    {
      name: "Name",
      selector: (row) => row?.rewardName,
      sortable: false,
      center: false,
      wrap: true,
      minWidth: "30%",
      maxWidth: "30%",
      cell: (row) => (
        <div style={{ width: "100%" }}>
          <p style={{ textAlign: "left", margin: "0" }}>{row?.rewardName}</p>
        </div>
      ),
    },
    {
      name: "Type",
      selector: (row) => row?.rewardType,
      sortable: false,
      center: true,
      minWidth: "20%",
      maxWidth: "20%",
      cell: (row) => (
        <div style={{ width: "" }}>
          <p
            style={{
              margin: "0",
              textAlign: "center",
              backgroundColor: "#e3717178",
              color: "#000",
              padding: "5px 10px",
              borderRadius: "5px",
              width: "auto",
            }}
          >
            {row?.rewardType}
          </p>
        </div>
      ),
    },
    {
      name: "Expiry Date",
      selector: (row) => row?.expiryDate,
      sortable: false,
      center: true,
      minWidth: "20%",
      maxWidth: "20%",
    },
    {
      name: "Set By",
      selector: (row) => row?.setBy,
      sortable: false,
      center: true,
      minWidth: "20%",
      maxWidth: "20%",
    },
  ];

  const menuOptionColumn = {
    name: "",
    selector: (row) => row.action,
    sortable: false,
    center: true,
    minWidth: "10%",
    maxWidth: "10%",
    wrap: true,
    cell: (row) => (
      <div style={{ display: "flex", gap: "5px" }}>
        {role === "seller" && (
          <button
            style={{ background: "none", border: "none" }}
            onClick={() => {
              setEditRewardId(row?.rewardId);
              setIsAddRewardModalOpen(true);
            }}
          >
            <img
              src={EditTableIcon}
              alt="edit"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
        )}
        <button
          style={{ background: "none", border: "none" }}
          onClick={() => {
            setDeleteRewardId(row?.rewardId);
            setIsDeleteRewardModalOpen(true);
          }}
        >
          <img
            src={deleteIcon}
            alt="delete"
            style={{ width: "25px", height: "25px" }}
          />
        </button>
      </div>
    ),
  };

  const columns = [...productsColumns, menuOptionColumn];
  return (
    <div>
      <DataTableComponent
        tableColumns={columns}
        tableData={tableData}
        highlightOnHover
        onRowClicked={(row) => {}}
      />
    </div>
  );
};

export default Table;
